(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-announcement-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var splide = new Splide( '#announcement-carousel', {
    type: 'fade',
    perPage: 1,
    rewind: true,
    padding: { left: '0px', right: '0px' },
    arrows: false,
    pagination: false,
    pauseOnHover: true,
    pauseOnFocus: false,
    autoplay: true,
    reducedMotion: {
      interval: 2000,
      speed: 500,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplay: "play",
    }        
  }).mount();
  // Height update function
  function updateHeight() {
    const activeSlide = splide.Components.Slides.getAt(splide.index);
    if (activeSlide) {
      // All content elements within the <li> slide
      const contentElements = activeSlide.slide.querySelectorAll('div');
      let maxHeight = 0;
      // Find the highest element
      contentElements.forEach(element => {
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });
      // Set the height
      splide.root.style.height = `${maxHeight}px`;
    }
  }
  splide.on('mounted', updateHeight);
  splide.on('moved', updateHeight);
  splide.on('active', updateHeight);
  // Update height when window is resized
  window.addEventListener('resize', updateHeight);
});

  } catch(e) { console.error(e); }
})();
})();
